import type { ReactNode } from "react";
import { Row } from "react-grid-system";
import type { RowProps } from "react-grid-system";
import styled from "styled-components";
import { theme } from "../../theme";

const StyledRow = styled(Row).attrs({ gutterWidth: 16 })`
  padding: 16px 8px;
  background-color: ${theme.colors.grey02};
  border-bottom: 1px solid ${theme.colors.grey05};
`;

const TableHeader = ({
  children,
  ...props
}: Omit<RowProps, "ref"> & { children: ReactNode }) => (
  <div style={{ padding: "0 8px" }}>
    <StyledRow {...props}>{children}</StyledRow>
  </div>
);

export default TableHeader;
